import { Button } from '@fluentui/react-components'
import styles from './Buttons.module.css'
import { forwardRef, ForwardedRef } from 'react'

interface ActionButtonProps {
  text: string
  buttonStyles: string[]
  handleOnClick: () => void
  disabled?: boolean
}

const ActionButton = forwardRef(
  (
    { text, handleOnClick, disabled, buttonStyles }: ActionButtonProps,
    ref: ForwardedRef<HTMLButtonElement>
  ) => (
    <Button
      ref={ref}
      className={`${styles.actionButton} ${buttonStyles
        .map((style) => styles[style])
        .join(' ')}`}
      onClick={handleOnClick}
      disabled={disabled}
    >
      {text}
    </Button>
  )
)

ActionButton.displayName = 'ActionButton'

export default ActionButton
